// @flow

import * as React from 'react';
import Emojify from 'app/components/shared/Emojify';

type Props = {
  job: {
    agentName: string,
    agentVersion: string
  }
};

export default class JobUsedAgentNoPluginsWarning extends React.PureComponent<Props> {
  render() {
    return (
      <div
        className="flex items-center mb2 border rounded border-dark-gray border-red red"
        role="alert"
      >
        <div className="px3 py2">
          <Emojify text=":rotating_light:" />
        </div>
        <div className="flex-auto pr3 py2">
          <a href="/docs/agent/v3/plugins">
            Plugins
          </a>
          {` are not supported by agent "${this.props.job.agentName}". This agent is v${this.props.job.agentVersion}, plugins require agent v3.0 and above.`}
          <br />
          {'To upgrade, see the '}
          <a href="/docs/agent/v3/upgrading">
            Upgrading to Buildkite Agent v3
          </a>
          {' guide.'}
        </div>
      </div>
    );
  }
}
